CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
Dates = require 'app/scripts/lib/dates'
Invitation = require 'app/scripts/models/invitation'

class InvitationList extends CollectionWithHelpers
  model: Invitation

  initialize: (list, @options) ->

  comparator: (invitation) ->
    if invitation.get('dateExpires')
      -(Dates.parse(invitation.get('dateExpires')))
    else
      -Infinity

module.exports = InvitationList
